import styled from 'styled-components'
import media from 'styled-media-query'

export const Logo = styled.div`
    margin: 0 auto;
    width: 120px;
`
